import { atom } from "recoil";

export const SelectedAssetState = atom<string | null>({
  key: "selectedAssetState",
  default: null,
});
